export default function guest({ next, store }) {
  if (!process.server && store.getters["auth/loggedIn"]) {
    return next({
      name: "Profile",
    });
  }
  next();
}
